export default __webpack_public_path__ + "media/titles/title_6_locale_nb-80e7f76e.png";